import "./App.css";

function App() {
    return (
        <div className="wrapper">
            <h1 className="glitch" data-text="SOMETHING IS COMING">
                SOMETHING IS COMING
            </h1>

            <div className="tag">
                Crafted by <span>Yassine El Ansari</span>
            </div>
        </div>
    );
}

export default App;
